// Centralized image imports
// This file imports all images and exports them as a structured object

import logoBlack from './logo/ciso-adapt-logo-dark.svg'
import logoLight from './logo/ciso-adpat-logo-light.svg'

// utils
import loginPageSide from './utils/login-page-side.webp'

// icon
import appleIcon from './icon/apple-icon.svg'
import asanaIcon from './icon/asana.svg'
import azureIcon from './icon/azure-icon.svg'
import atlassianIcon from './icon/atlassian-icon.svg'
import catoIcon from './icon/cato-icon.webp'
import discordIcon from './icon/discord.svg'
import drataWhiteIcon from './icon/drata-icon-white.svg'
import drataIcon from './icon/drata-icon.svg'
import dropboxIcon from './icon/dropbox.svg'
import geminiIcon from './icon/gemini.svg'
import gmailIcon from './icon/gmail.svg'
import googleCalendarIcon from './icon/google-calendar.svg'
import googleCloudIcon from './icon/google-cloud.svg'
import googleDriveIcon from './icon/google-drive.svg'
import googleIcon from './icon/google-icon.svg'
import googleSheetsIcon from './icon/google-sheets.svg'
import jiraIcon from './icon/jira-icon.svg'
import microsoftIcon from './icon/microsoft-icon.svg'
import outlookIcon from './icon/microsoft-outlook.svg'
import sharepointIcon from './icon/microsoft-sharepoint.svg'
import teamsIcon from './icon/microsoft-teams-icon.svg'
import mimecastIcon from './icon/mimecast-icon.png'
import msDefenderIcon from './icon/ms-defender-icon.webp'
import n8nIcon from './icon/n8n-icon.svg'
import notionIcon from './icon/notion.svg'
import openaiIcon from './icon/openai.svg'
import paloAltoNetworksIcon from './icon/palo-network-icon.png'
import phishedIcon from './icon/phished-logo.jpeg'
import runZeroIcon from './icon/run-zero-icon.webp'
import slackIcon from './icon/slack-icon.svg'
import tenableIcon from './icon/tenable-icon.svg'
import vantaIcon from './icon/vanta-icon.svg'
import vantaWhiteIcon from './icon/vanta-white-icon.svg'
import zapierIcon from './icon/zapier-icon.svg'

const assetImages = {
  logo: {
    logoBlack,
    logoLight,
  },
  utils: {
    loginPageSide,
  },
  icons: {
    appleIcon,
    googleIcon,
    microsoftIcon,
    runZeroIcon,
    catoIcon,
    tenableIcon,
    jiraIcon,
    paloAltoNetworksIcon,
    msDefenderIcon,
    mimecastIcon,
    slackIcon,
    teamsIcon,
    zapierIcon,
    phishedIcon,
    n8nIcon,
    sharepointIcon,
    gmailIcon,
    googleSheetsIcon,
    googleDriveIcon,
    asanaIcon,
    notionIcon,
    dropboxIcon,
    discordIcon,
    outlookIcon,
    googleCloudIcon,
    googleCalendarIcon,
    openaiIcon,
    geminiIcon,
    azureIcon,
    atlassianIcon,
    drataIcon,
    drataWhiteIcon,
    vantaIcon,
    vantaWhiteIcon,
  },
} as const

export const images = {
  ...assetImages,
} as const

export const logoImages = assetImages.logo
export const utilsImages = assetImages.utils
export const iconImages = assetImages.icons

export type ImageKey = keyof typeof images
export type LogoImageKey = keyof typeof logoImages
export type UtilsImageKey = keyof typeof utilsImages
export type IconImageKey = keyof typeof iconImages

export default images
